export default __webpack_public_path__ + "static/char-s-45-zh-Hans-1aedbbe66ebf01d0e16190c88a3dfefd.png";